import { API_AUTH } from "../common";

const LichSuGiaoDichBankApi = {
  list: ({ sSoTaiKhoan, iPageSize, iPageIndex, TuNgay, DenNgay }) =>
    API_AUTH.get(
      `lichsugiaodich/danhsach?sSoTaiKhoan=${sSoTaiKhoan}&TuNgay=${TuNgay}&DenNgay=${DenNgay}&iPageSize=${iPageSize}&iPageIndex=${iPageIndex}`,
      {}
    ),

  dongBoDuLieuBank: ({ BankId, NgayGiaoDich }) => API_AUTH.post("lichsugiaodich/dongBoDuLieuBank?BankId=" + BankId + "&NgayGiaoDich=" + NgayGiaoDich),

};

export default LichSuGiaoDichBankApi;
